import React from 'react';
import './BusinessSwitcher.css';

const BusinessSwitcher = ({ businessIds, activeBusinessId, onSwitch }) => {
    if (!businessIds || businessIds.length <= 1) return null;

    return (
        <div className="business-switcher">
            <select
                value={activeBusinessId}
                onChange={(e) => onSwitch(parseInt(e.target.value, 10))}
                className="business-select"
            >
                {businessIds.map((biz) => {
                    const id = typeof biz === 'object' ? biz.id : biz;
                    const name = typeof biz === 'object' ? (biz.name || `Business ${biz.id}`) : `Business ${biz}`;
                    return (
                        <option key={id} value={id}>
                            {name}
                        </option>
                    );
                })}
            </select>
        </div>
    );
};

export default BusinessSwitcher;
